import { Table } from "@tanstack/react-table";
import { Button } from "@pushpress/pushpress-ui";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface TablePaginationProps<TData> {
  table: Table<TData>;
}

export default function TablePagination<TData>({
  table,
}: TablePaginationProps<TData>) {
  return (
    <div className="tw-flex tw-items-center tw-justify-between">
      <div className="tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-medium">
        {table.getFilteredRowModel().rows.length >= 1 && (
          <span
            className="tw-text-sm tw-text-neutral-800"
            data-testid="pagination-info-showing"
          >
            <span className="max-sm:tw-hidden">Showing </span>
            {table.getState().pagination.pageIndex *
              table.getState().pagination.pageSize +
              1}{" "}
            to{" "}
            {Math.min(
              (table.getState().pagination.pageIndex + 1) *
                table.getState().pagination.pageSize,
              table.getFilteredRowModel().rows.length,
            )}{" "}
            of {table.getFilteredRowModel().rows.length}
          </span>
        )}
      </div>
      <div className="tw-flex tw-items-center tw-space-x-2">
        {table.getFilteredRowModel().rows.length >= 1 && (
          <span
            className="tw-text-sm tw-text-neutral-800 tw-mr-2"
            data-testid="pagination-info-current-page"
          >
            <span className="max-sm:tw-hidden">Page </span>
            {table.getState().pagination.pageIndex + 1} of{" "}
            <span className="tw-text-neutral-800">{table.getPageCount()}</span>
          </span>
        )}
        <Button
          variant="outline"
          size="icon"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          <ChevronLeft className="tw-h-4 tw-w-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          <ChevronRight className="tw-h-4 tw-w-4" />
        </Button>
      </div>
    </div>
  );
}
